import React from "react";


export const Spacer: React.FC = () => {

    return (
       <div style={{width: 20, height: 20}} />
    );
};
